import { render, staticRenderFns } from "./custom-overlay.vue?vue&type=template&id=145dc58d&scoped=true"
import script from "./custom-overlay.vue?vue&type=script&lang=ts"
export * from "./custom-overlay.vue?vue&type=script&lang=ts"
import style0 from "./custom-overlay.vue?vue&type=style&index=0&id=145dc58d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145dc58d",
  null
  
)

export default component.exports